import React from "react";
import {
  List,
  ListItemButton,
  ListItemText,
  Chip,
  Stack,
  Typography,
} from "@mui/material";

export default function ModuleList({ modules, selectedModule, onSelect }) {
  if (!modules || modules.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No modules found in planner_file_map.
      </Typography>
    );
  }

  const handleSelect = (modName) => {
    if (onSelect) {
      onSelect(modName);
    }
  };

  return (
    <List dense sx={{ maxHeight: "100%", overflow: "auto", p: 0 }}>
      {modules.map((mod) => {
        const isSelected = selectedModule === mod.module;
        const tablesCount = (mod.tables_used || []).length;

        return (
          <ListItemButton
            key={mod.module}
            selected={isSelected}
            onClick={() => handleSelect(mod.module)}
            sx={{ borderRadius: 1, mb: 0.5, alignItems: "flex-start" }}
          >
            <ListItemText
              primary={
                <Typography variant="body2" sx={{ wordBreak: "break-word", fontWeight: isSelected ? 700 : 500 }}>
                  {mod.module}
                </Typography>
              }
              secondary={
                <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap sx={{ mt: 0.5 }}>
                  <Typography variant="caption">
                    {mod.file_count} file{mod.file_count === 1 ? "" : "s"}
                  </Typography>
                  {tablesCount > 0 && (
                    <Chip
                      label={`${tablesCount} table${tablesCount === 1 ? "" : "s"}`}
                      size="small"
                    />
                  )}
                </Stack>
              }
            />
          </ListItemButton>
        );
      })}
    </List>
  );
}
